

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { networkSvc } from '@/services';
import {
  NetworkTemplate,
  NetworkAccountOption,
  Network,
  NetworkAccountOptionDetail
} from '@/types';
import NetworkAccountOptions from './NetworkAccountOptions.vue';

@Component({
  name: 'network-instructions',
  components: {
    NetworkAccountOptions
  }
})
export default class NetworkInstructions extends Vue {
  @Prop()
  private network!: Network;

  isLoading: boolean = false;

  async saveNetwork() {
    this.isLoading = true;
    if (this.network.network_account_option) {
      await networkSvc.updateNetworkAccountOption(
        this.network.network_account_option!
      );
    }
    await networkSvc.updateNetwork({
      id: this.network.id,
      affiliate_code_description: this.network.affiliate_code_description
    });
    this.isLoading = false;
  }
}
